import React from 'react';
import { FlameIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const perks = ['Sofortiger digitaler Zugriff', 'Alle 3 Boni enthalten', 'Nur Einmalzahlung', 'Niemals ein Abo'];
export function FinalCta() {
  return <section className="w-full bg-ink py-20 text-white sm:py-28" data-id="element-52" data-mp="19cup66srd0qa">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-53" data-mp="15ckjkv8vocby">
        <p className="mb-5 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-54" data-mp="1jcliw69hvbpb">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="1ed0ma2hsrffr" />
          Letzte Chance — limitiertes Angebot
        </p>
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl md:text-5xl" data-id="element-56" data-mp="1t2ew1bpabyvo">
          Deine Kinder verdienen es, etwas Echtes zu bauen
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-57" data-mp="222uxkfmgwvxw">
          Schenke ihnen 100+ Roboter-Projekte, 3 gratis Boni und stundenlangen
          bildschirmfreien Spaß — alles für eine einmalige Zahlung.
        </p>
        <div className="mt-10" data-id="element-58" data-mp="n7fhlussdcg7">
          <CtaButton data-id="element-59" data-mp="s4fk5vqffx2k">Ja! Ich will MakerLab jetzt</CtaButton>
        </div>
        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/70" data-id="element-60" data-mp="s6s2ia03k9g5">
          {perks.map(p => <li key={p} className="flex items-center gap-1.5" data-id="element-61" data-mp="123555xdmdxn1">
              <CheckIcon className="h-4 w-4 text-emerald-400" aria-hidden="true" data-id="element-62" data-mp="120inv60xg3rm" />
              {p}
            </li>)}
        </ul>
      </div>
    </section>;
}